import React from 'react';
import PropTypes from 'prop-types';

import TabHeaderContainer from '../domain-management/tab-header-container';
import TabFilterButtons from '../domain-management/tab-filter-buttons';
import ClaimedDomainsTableContainer from './claimed-domains-table-container';

export const ClaimedDomains = ( {
    match,
    selectedDomainFilter,
} ) => {
    return (
        <>
            <TabHeaderContainer type="claimed" />
            {
                selectedDomainFilter &&
                ( <TabFilterButtons
                    domainType="claimed"
                    match={match}
                    selectedDomainFilter={selectedDomainFilter}
                /> )
            }
            <ClaimedDomainsTableContainer
                selectedDomainFilter={selectedDomainFilter}
            />
        </>
    );
};

ClaimedDomains.propTypes = {
    match: PropTypes.shape( {
        params: PropTypes.shape( {
            collectionId: PropTypes.string
        } ),
        url: PropTypes.string,
    } ),
    selectedDomainFilter: PropTypes.string,
};


export default ClaimedDomains;
